import { testimonials } from '@/mocks/testimonials';

export default function TestimonialSection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="mb-10">
            <span className="inline-block px-3 py-1 text-xs font-semibold text-accent-700 bg-accent-100 rounded-full mb-3 whitespace-nowrap">
              Community
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-semibold text-foreground-950 leading-tight">
              What Our Users Say
            </h2>
            <p className="text-sm text-foreground-500 mt-2 max-w-md">
              Real feedback from the CSSBuy community who use these spreadsheets daily.
            </p>
          </div>

          {/* Masonry Grid */}
          <div className="columns-1 md:columns-2 lg:columns-3 gap-5 space-y-5">
            {testimonials.map((t) => (
              <div
                key={t.handle}
                className="break-inside-avoid bg-background-50 rounded-2xl p-5 border border-background-200/70"
              >
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                    <img
                      src={t.avatar}
                      alt={t.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-foreground-900 whitespace-nowrap">
                      {t.name}
                    </p>
                    <p className="text-xs text-foreground-400 whitespace-nowrap">
                      {t.handle}
                    </p>
                  </div>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed italic">
                  &ldquo;{t.text}&rdquo;
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}